export const stickyCta = () => {
  const container = document.querySelector(".js-sticky-cta");
  const toggle = container?.querySelector(".js-sticky-cta-toggle");
  const close = container?.querySelector(".js-sticky-cta-close");
  const panel = container?.querySelector(".js-sticky-cta-panel");
  const buttonWrap = container?.querySelector(".s-sticky-cta__button");

  if (!container || !toggle || !close || !panel || !buttonWrap) {
    return;
  }

  let isAnimating = false;

  const onTransitionEnd = (el, callback) => {
    el.addEventListener("transitionend", function handler(e) {
      if (e.propertyName !== "transform") return;
      el.removeEventListener("transitionend", handler);
      callback();
    });
  };

  const open = () => {
    if (isAnimating) return;
    isAnimating = true;

    toggle.setAttribute("aria-expanded", "true");
    toggle.setAttribute("aria-label", "お問い合わせフォームを閉じる");
    container.classList.add("is-open");

    // Phase 1: ボタンを右へスライドアウト
    buttonWrap.style.transform = "translateX(100%)";

    onTransitionEnd(buttonWrap, () => {
      // Phase 2: ボタンを隠し、パネルを右から左へスライドイン
      buttonWrap.style.display = "none";
      buttonWrap.style.transform = "";

      panel.style.display = "block";
      panel.style.transform = "translateX(100%)";
      panel.offsetHeight;
      panel.style.transform = "translateX(0)";

      onTransitionEnd(panel, () => {
        isAnimating = false;
      });
    });
  };

  const closePanel = () => {
    if (isAnimating) return;
    isAnimating = true;

    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-label", "お問い合わせフォームを開く");
    container.classList.remove("is-open");

    // Phase 1: パネルを右へスライドアウト
    panel.style.transform = "translateX(100%)";

    onTransitionEnd(panel, () => {
      // Phase 2: パネルを隠し、ボタンを右から左へスライドイン
      panel.style.display = "none";
      panel.style.transform = "";

      buttonWrap.style.display = "flex";
      buttonWrap.style.transform = "translateX(100%)";
      buttonWrap.offsetHeight;
      buttonWrap.style.transform = "translateX(0)";

      onTransitionEnd(buttonWrap, () => {
        buttonWrap.style.transform = "";
        isAnimating = false;
      });
    });
  };

  // PC時はデフォルトでフォームパネルを表示（data-initial-state="closed" の場合はスキップ）
  const isPC = window.matchMedia("(min-width: 769px)").matches;
  const initialState = container.dataset.initialState;

  if (isPC && initialState !== "closed") {
    buttonWrap.style.display = "none";
    panel.style.display = "block";
    panel.style.transform = "translateX(0)";
    container.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");
    toggle.setAttribute("aria-label", "お問い合わせフォームを閉じる");
  }

  toggle.addEventListener("click", () => {
    const isExpanded = toggle.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
      closePanel();
    } else {
      open();
    }
  });

  close.addEventListener("click", () => {
    closePanel();
    toggle.focus();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && container.classList.contains("is-open")) {
      closePanel();
      toggle.focus();
    }
  });
};
